class ApiUrlManager {
  private static instance: ApiUrlManager;
  private localstorageKey: string = 'apiBaseUrl';
  private localStorageTenantKey: string = 'tenantID';

  private constructor() {}

  public static getInstance(): ApiUrlManager {
    if (!ApiUrlManager.instance) {
      ApiUrlManager.instance = new ApiUrlManager();
    }
    return ApiUrlManager.instance;
  }

  public setBaseUrl(url: string) {
    if (!url) {
      throw new Error('Base URL cannot be empty');
    }
    var baseUrl = url.endsWith('/') ? url.slice(0, -1) : url; // Ensure no trailing slash
    localStorage.setItem(this.localstorageKey, baseUrl);
  }

  public setTenantID(tenantID: string) {
    if (!tenantID) {
      throw new Error('Tenant ID cannot be empty');
    }
    //this.tenantID = domain.replace(/\./g, '_'); // Replace periods with underscores
    localStorage.setItem(this.localStorageTenantKey, tenantID);
  }

  public getApiUrl(): string {
    const baseUrl = localStorage.getItem(this.localstorageKey);
    if (!baseUrl) {
      throw new Error('Base URL is not set');
    }
    const tenantID = localStorage.getItem(this.localStorageTenantKey);
    if (!tenantID) {
      throw new Error('Tenant ID is not set');
    }
    return `${baseUrl}/api/${tenantID}`;
    
  }
}

export default ApiUrlManager.getInstance();
